import { RouterModule, Routes } from '@angular/router';
import { ActionsComponent } from './actions.component';
import { NgModule } from '@angular/core';

const routes: Routes = [
  {
    path: '',
    component: ActionsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class ActionsRoutingModule {}
